module.exports = __webpack_public_path__ + "img/skate3-smaller.02651660.jpeg";